import { PermissionType } from "@/pages/Configuration/AdminConfiguration/Users/types/cognitoTypes";
import { px, rem } from "csx";
import { Vertical, VerticalSpacer } from "gls";
import { useAtom } from "jotai";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { defaultSearchParams, selectedSideBarMenuAtom } from "../Sidebar";
import { SidebarItem } from "../SidebarItem";
import { SUBMENU_ROUTES } from "../routes";
import { SubMenuLayout } from "./SubMenuLayout";
import { useFeatureFlag } from "@/shared/hooks/useFeatureFlag";

export const SideBarSupportMenu: FC = () => {
  const { t } = useTranslation();
  const [_, setSelectedMenu] = useAtom(selectedSideBarMenuAtom);
  const isNotificationsEnabled = useFeatureFlag("FEATUREFLAG_NOTIFICATIONS");
  const isVideoSettingsEnabled = useFeatureFlag("FEATUREFLAG_VIDEO_SETTINGS");

  return (
    <SubMenuLayout
      title={t("Support")}
      previousTitle={t("Main Menu")}
      onBack={() => setSelectedMenu("main")}
    >
      <VerticalSpacer height={rem(1)} />

      <Vertical padding={[0, 0, px(14), rem(2)]} spacing={rem(0.5)}>
        <SidebarItem
          hideTextWhenCollapsed
          isCollapsed={false}
          text={"Integrations"}
          permissionName={SUBMENU_ROUTES.integrations.permission}
          navigateTo={SUBMENU_ROUTES.integrations.path}
          navigateSearch={defaultSearchParams}
        />
        <SidebarItem
          hideTextWhenCollapsed
          isCollapsed={false}
          text={"Equipment"}
          permissionName={SUBMENU_ROUTES.equipment.permission}
          navigateTo={`${SUBMENU_ROUTES.equipment.path}/pens`}
          matchTo={SUBMENU_ROUTES.equipment.path}
          navigateSearch={defaultSearchParams}
        />
        <SidebarItem
          hideTextWhenCollapsed
          isCollapsed={false}
          text={"Local Servers"}
          permissionName={SUBMENU_ROUTES.localServers.permission}
          navigateTo={SUBMENU_ROUTES.localServers.path}
          navigateSearch={defaultSearchParams}
          data-testid="local-servers-menu-item"
        />
        <SidebarItem
          hideTextWhenCollapsed
          isCollapsed={false}
          text={"Data Router"}
          permissionName={SUBMENU_ROUTES.dataRouter.permission}
          navigateTo={SUBMENU_ROUTES.dataRouter.path}
          navigateSearch={defaultSearchParams}
        />
        <SidebarItem
          isCollapsed={false}
          hideTextWhenCollapsed
          text={t("Troubleshooting")}
          permissionName={PermissionType.Support}
          navigateTo={"/marlin-v2/admin-configuration/troubleshooting"}
          navigateSearch={defaultSearchParams}
        />
        {isNotificationsEnabled && (
          <SidebarItem
            isCollapsed={false}
            hideTextWhenCollapsed
            text={t("Notification Settings")}
            permissionName={SUBMENU_ROUTES.notificationSettings.permission}
            navigateTo={SUBMENU_ROUTES.notificationSettings.path}
            navigateSearch={defaultSearchParams}
            data-testid="notification-settings-menu-item"
          />
        )}
        {isVideoSettingsEnabled && (
          <SidebarItem
            isCollapsed={false}
            hideTextWhenCollapsed
            text={t("Video Page Settings")}
            permissionName={SUBMENU_ROUTES.videoSettings.permission}
            navigateTo={SUBMENU_ROUTES.videoSettings.path}
            navigateSearch={defaultSearchParams}
            data-testid="video-settings-menu-item"
          />
        )}
        <SidebarItem
          isCollapsed={false}
          hideTextWhenCollapsed
          text={t("Feeding Settings")}
          permissionName={SUBMENU_ROUTES.feedingSettings.permission}
          navigateTo={SUBMENU_ROUTES.feedingSettings.path}
          navigateSearch={defaultSearchParams}
        />
        <SidebarItem
          isCollapsed={false}
          hideTextWhenCollapsed
          text={"Gamepad Settings"}
          navigateTo={"/marlin-v2/admin-configuration/key-bindings"}
          navigateSearch={defaultSearchParams}
        />
        <SidebarItem
          isCollapsed={false}
          hideTextWhenCollapsed
          text={"Update Settings"}
          navigateTo={"/marlin-v2/admin-configuration/auto-update-settings"}
          navigateSearch={defaultSearchParams}
        />
      </Vertical>
    </SubMenuLayout>
  );
};
